import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "../../styles/whatsapp-icon.css";

const WhatsAppIcon = () => {
  return (
    <a
      href="https://wa.me/40741383836?text=Salut!"
      className="whatsapp_float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrie pe WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppIcon;
